export class PriceOracle {
    constructor(cache) {
        this.cache = cache;
    }
    static index(prices) {
        const cache = new Map();
        prices.forEach((price) => cache.set(price.getMintId().toString(), price));
        return new PriceOracle(cache);
    }
    getPrice(mintId) {
        const key = mintId.toString();
        return this.cache.get(key);
    }
}
//# sourceMappingURL=PriceOracle.js.map